import React from 'react'
import FlexView from 'react-flexview/lib'
import { AdditionalPopover } from '../../Core/Popover/AdditionalInsuredPopover'
import { GridList, Grid } from '@material-ui/core'
import { ReactComponent as AddSvg } from '../../../assets/add.svg';
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../../context/InsuracePurchaseContext'
import { AdditionalInsuredView } from '../../Core/AdditionalInsured/AdditionalInsureView'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { ReactComponent as PersonCircle } from '../../../assets/person_with_circle.svg'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { isMobile } from 'react-device-detect'
import { OperatorAddForm } from '../../Operators/OperatorAddForm'
import { Action } from '../../../models/Action'
import ViolationsService from '../../../services/ViolationsService'
import { BuyingInsuranceContextStore, OFFERS_ACTIOS } from '../../../context/BuyingInsuranceContext';
import { OperatorsPopover } from '../../Core/Popover/OperatorsPopover';


export const CustomizeOperatorsSection = () => {
    const offersContext = React.useContext(BuyingInsuranceContextStore)
    const [showAddOperatorPopup, setShowAddOperatorPopup] = React.useState(false)
    const [error, setError] = React.useState('')
    const isFirstRun = React.useRef(true);

    
    // Validate Operators effect
    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.FLOW_VALIDATE_EVENT, validateOperators)

        if (isFirstRun.current) {
            isFirstRun.current = false;
        }
        else {
            // Validate after the inital render
            validateOperators()
        }

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.FLOW_VALIDATE_EVENT, id)
        }

    }, [offersContext.operators])


    const validateOperators = () => {
        if(!ViolationsService.checkOperatorsViolations(offersContext.operators) ) {
            setError('At least one operator should be added')
        }
        else {
            setError('')
        }
    }

    const openAddOperator = () => setShowAddOperatorPopup(true)
    const closeAddOperator = () => setShowAddOperatorPopup(false)
    const addOperator = (operator, editIndex) => {
        if(editIndex != -1) 
            offersContext.dispatch(new Action(OFFERS_ACTIOS.EDIT_OPERATOR, {operator: operator, index: editIndex}))
        else
            offersContext.dispatch(new Action(OFFERS_ACTIOS.ADD_OPERATOR, operator))
    }
    
    const deleteOperator = (index) => offersContext.dispatch(new Action(OFFERS_ACTIOS.DELETE_OPERATOR, index))

    return (
        <React.Fragment>
            <FlexView vAlignContent={'center'} className="space-between margin-top-basic">
                <FlexView vAlignContent={'center'}>
                    <div className="text-body bold black">Operators </div>
                    <OperatorsPopover />
                </FlexView>
            </FlexView>
            
            {!isMobile && <div className="text-body dark-grey margin-bottom-6 margin-top-small">Add the operators that need to be covered now. You can add and remove additional operators at any point</div>}
            {isMobile && <Grid container className="margin-top-small">
                    <Grid xs item>
                        <div className="text-body dark-grey margin-top-small">Add the operators that need to be covered now. You can add and remove additional operators at any point</div>
                    </Grid>
                    <Grid item>
                        <AddSvg onClick={openAddOperator} className="clickable blue-svg-path add" />
                    </Grid>
                </Grid>}

            {error && <div className={`text-body red`}>{error}</div>}
            
            <GridList spacing={2}>
                {offersContext.operators.map((ai, index) => <AdditionalInsuredView onEdit={openAddOperator} key={index} ai={ai} />)}
            </GridList>

            {!isMobile && 
                <FlexView className="clickable" onClick={openAddOperator} vAlignContent={'center'}>
                    <AddSvg className="add blue-svg-path" /> <span className="text-body blue">Add operator</span>
                </FlexView>}

            <SkywatchDialog 
                open={showAddOperatorPopup}
                closeDialog={closeAddOperator}
                maxWidth={isMobile ? 'md' : 'xs'}
                circleHeader={<PersonCircle />}
                closeTitle={'Add Operator'}>
                    <OperatorAddForm 
                        operators={offersContext.operators} 
                        onOpAdd={addOperator} 
                        onOpDelete={deleteOperator} 
                        onFinish={closeAddOperator} />
            </SkywatchDialog>
        </React.Fragment>
    )
}